<div class="flex min-h-dvh flex-col bg-app-surface font-sans text-app-ink">
  <!--
    Sticky rather than fixed: the shell is min-h-dvh, so the document itself is what scrolls and the
    header pins against the viewport while keeping its place in the flex column.
  -->
  <header
    class="sticky top-0 z-30 flex min-h-16 flex-none items-center justify-between gap-4 bg-app-card px-4 shadow-sm"
  >
    <div class="flex items-center gap-4">
      <img src="xpo-logo.png" alt="XPO" class="ml-0.5 h-7 w-auto" />
      <span class="text-xl font-light text-app-ink">JMeter Runner</span>
    </div>
    <app-theme-toggle />
  </header>

  <main class="flex flex-1 flex-col overflow-auto">
    <router-outlet />
  </main>
</div>
